import sessionStorageModule from '../utils/sessionStorageModule.js';
import { personDetails } from '../helper/PersonDetails.js';

/**
 * Checks if the user is logged in and returns the user data.
 *
 * @returns {Promise<Object|null>} - A promise that resolves with the user data,
 *                                    or null if the user is not logged in.
 */
export function isLoggedIn() {
  return new Promise((resolve) => {
    Eventive.on('ready', () => {
      if (Eventive.isLoggedIn()) {
        const userDetails = Eventive.getPersonDetails();
        setupLogoutHandler(); // Separate function for the logout handler
        resolve(userDetails);
      } else {
        resolve(null);
      }
    });
  });
}

/**
 * Sets up the logout handler that removes the user data from session storage
 * when the user clicks the logout link.
 */
function setupLogoutHandler() {
  const logoutLink = document.querySelector('a[href="#logout"]');
  if (logoutLink) {
    logoutLink.addEventListener('click', (event) => {
      event.preventDefault();
      sessionStorageModule.removeItem('gd-checkout-data');
      handleUserLoginStatus(null, '');
      personDetails.set({});
    });
  }
}

/**
 * Handles the user's login status and adjusts the visibility of
 * certain DOM elements accordingly.
 *
 * @param {Object|null} user - The user data if the user is logged in, otherwise null.
 * @param {string} token - The userToken.
 * @returns {Object} - An object that contains the login status and user data.
 */
export function handleUserLoginStatus(user, token) {
  const userData = {
    isUserLoggedIn: !!user,
    user: user || null,
    token: token || '',
  };
  personDetails.set(userData);

  const couponField = document.getElementById('gd__checkout__discountCode');
  const loginNote = document.getElementById('gd__checkout__login__note');
  const registerButton = document.getElementById('gd__checkout__register__button');
  const couponInputField = document.getElementById('gd__checkout__discountCode__input');
  const selfTicketsButton = document.querySelectorAll('.self_tickets');

  // Set the visibility of elements based on login status
  if (userData.isUserLoggedIn) {
    if (couponField) {
      couponField.style.display = 'block';
    }
    if (loginNote) {
      loginNote.style.display = 'none';
    }
    if (registerButton) {
      registerButton.style.display = 'none';
    }
  } else {
    if (couponField) {
      couponField.style.display = 'none';
    }
    if (couponInputField) {
      couponInputField.value = ''; // Clear the input field
    }
    if (loginNote) {
      loginNote.style.display = 'inline';
    }
    if (registerButton) {
      registerButton.style.display = 'block';
    }

    if(selfTicketsButton.length > 0) {
      selfTicketsButton.forEach(button => {
        button.style.display = 'none';
      });
    }
  }

  return personDetails.get();
}
